import script from "./router_0J3316.vue?vue&type=script&setup=true&lang=js"
export * from "./router_0J3316.vue?vue&type=script&setup=true&lang=js"

import "./router_0J3316.vue?vue&type=style&index=0&id=3e08e695&lang=scss&scoped=true"

import exportComponent from "/www/auto.37games.com/@mono/buildSpace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e08e695"]])

export default __exports__